import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

    import test_img1 from '../Assets/Images/test1.jpeg';
    import test_img2 from '../Assets/Images/test1.jpeg';
    import test_img3 from '../Assets/Images/test1.jpeg';

    const testimonials = [
    {
        text: "I’ve been using NA Ayurveda’s face cream for a month now, and my skin feels so much smoother and brighter. I love that it’s all-natural and free from chemicals. Highly recommended!",
        name: "Manjinder",
        img: test_img1,
    },
    {
        text: "Great product! I had dull skin and frequent dryness. After switching to NA Ayurveda, my skin feels nourished and healthy. Will definitely try more products from this brand.",
        name: "Parneet",
        img: test_img2,
    },
    {
        text: "These Ayurvedic products are amazing! My skin feels smoother, clearer, and healthier. Totally chemical-free and perfect for my sensitive skin. I’ll definitely buy again.",
        name: "Kamal",
        img: test_img3,
    },
    ];

const TestMain = () => {
  const [index, setIndex] = useState(0);
  const [pause, setPause] = useState(false);

  // ✅ Auto slider (NO BLINK)
  useEffect(() => {
    if (pause) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [pause]);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <div className="test_sec">
      <Container>
        <Row>
          <Col lg={12}>
            <div
              className="test_wrapper"
              onMouseEnter={() => setPause(true)}
              onMouseLeave={() => setPause(false)}
            >

              <p className="tag">TESTIMONIAL</p>

              <h2>What Our People Says</h2>

              {/* ⭐ Stars */}
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="bi bi-star-fill"></i>
                ))}
              </div>

              {/* Content */}
              <div className="test_content">
                <i className="bi bi-chevron-left arrow" onClick={prevSlide}></i>

                <p className="">
                  {testimonials[index].text}
                </p>

                <i className="bi bi-chevron-right arrow" onClick={nextSlide}></i>
              </div>

              {/* Name */}
              <h5>{testimonials[index].name}</h5>

              {/* Image */}
              <div className="user_img">
                <img src={testimonials[index].img} alt="user" />
              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TestMain;